import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center px-4">
      <p className="text-muted text-xs font-medium tracking-[0.35em] uppercase">Lost in transit</p>
      <h1 className="font-heading text-primary mt-4 text-6xl font-normal tracking-[-0.05em]">
        404
      </h1>
      <p className="text-muted mt-4 max-w-sm text-center text-lg">
        This page doesn&apos;t exist in the current BOI workflow.
      </p>
      <Link
        to="/home"
        className="bg-accent text-accent-foreground hover:bg-accent/90 mt-8 rounded-md px-6 py-2 text-sm font-medium"
      >
        Return to workspace
      </Link>
    </div>
  );
}
